import React, { useEffect, useMemo, useState } from 'react'
import Barra from '../Modulos/Barra'
import { FaCompress } from '@react-icons/all-files/fa/FaCompress'
import { FaExpand } from '@react-icons/all-files/fa/FaExpand'
import { FaEyeSlash } from '@react-icons/all-files/fa/FaEyeSlash'
import { FaEye } from '@react-icons/all-files/fa/FaEye'
import { FaSearch } from '@react-icons/all-files/fa/FaSearch'
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import { FaFilter } from '@react-icons/all-files/fa/FaFilter'
import $ from "jquery";
import './Css/solicitudes.css';
import SolicitudesResponsive from '../components/responsive/SolicitudesResponsive'
import BaseModalCreateSolcitud from '../components/modals/baseModal'
import FormSolicitudesLog from '../components/formsSolicitudes/formSolicitudesLog'
import FormSolicitudesCli from '../components/formsSolicitudes/formSolicitudesCli'
import Swal from 'sweetalert2'
import FormUpdateSolicitudCli from '../components/formsSolicitudes/formUpdateSolicitudCli'
import FormUpdateSolicitudLog from '../components/formsSolicitudes/formUpdateSolicitudLog'
import FormSolicitudesMult from '../components/formsSolicitudes/formSolicitudesMult'
import CausalModal from '../components/modals/causalModal'
import CausalAnularSolicitud from '../components/formsSolicitudes/causalAnularSolicitud'
import ReporteSeguimientoModal from '../components/modals/rmodalSolicitud'
import FormReporteSolicitudes from '../components/formsSolicitudes/formReporteSolicitudes'
import axios from '../utils/axiosConfig'
import { formattedGlobalDate } from '../utils/formattedDates'
import BarraSolicitud from '../Modulos/BarraSolicitudes'
import Select, { components as selectComponents } from 'react-select'

const Solicitudes = () => {

    const SOLICITUDES_SEARCH_STORAGE_KEY = 'solicitudes:search';

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [listSolicitudes, setListSolicitudes] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [color, setColor] = useState('');
    const [statusForm, setStatusForm] = useState('');
    const [formType, setFormType] = useState(null);
    const [formTypeMult, setFormTypeMult] = useState(null);
    const [formTypeMCausalAnular, setFormTypeCausalAnular] = useState(null);
    const [formTypeReporteSeguimiento, setFormTypeReporteSeguimiento] = useState(null);
    const [formTypeUpdate, setFormTypeUpdate] = useState(null);
    const [clientes, setClientes] = useState(['-No asignado-']);
    const [infoByIdSolcitud, setInfoByIdSolcitud] = useState({});

    const [selectedCiudades, setSelectedCiudades] = useState([]);
    const [selectedEmpresas, setSelectedEmpresas] = useState([]);
    const [selectedColorFilters, setSelectedColorFilters] = useState([]);
    //Contadores de colores en solciitudes
    const [redCount, setRedCount] = useState(0);
    const [yellowCount, setYellowCount] = useState(0);
    const [blueCount, setBlueCount] = useState(0);
    const [greenCount, setGreenCount] = useState(0);
    const [transparentCount, setTransparentCount] = useState(0);

    const [bitOpen, setBitOpen] = useState(false);
    const [bitInsert, setBitInsert] = useState(false);
    const [bitEdit, setBitEdit] = useState(false);
    const [bitDelete, setBitDelete] = useState(false);

    const [isDialogOpenNewSolicitud, setIsDialogOpenNewSolicitud] = useState(false);
    const [isDialogOpenUpdateSolicitud, setIsDialogOpenUpdateSolicitud] = useState(false);
    const [isDialogOpenUpdateSolicitudMult, setIsDialogOpenUpdateSolicitudMult] = useState(false);
    const [isDialogOpenCausalAnular, setIsDialogOpenCausalAnular] = useState(false);
    const [isDialogOpenReportSeguimiento, setIsDialogOpenReportSeguimiento] = useState(false);
    const [isDialogOpenNewSolicitudDiff, setIsDialogOpenNewSolicitudDiff] = useState(false);

    const [filteredSolicitudes, setFilteredSolicitudes] = useState([]);
    const [filteredSolicitudesNotifications, setFilteredSolicitudesNotifications] = useState([]);
    const [isSolicitudesLoading, setIsSolicitudesLoading] = useState(true);
    const [searchValue, setSearchValue] = useState(() => sessionStorage.getItem(SOLICITUDES_SEARCH_STORAGE_KEY) || '');
    const [openSolicitudActions, setOpenSolicitudActions] = useState(null);

    useEffect(() => {
        document.body.classList.add('solicitudes-responsive-page');
        document.documentElement.classList.add('table-page-lock');
        return () => {
            document.body.classList.remove('solicitudes-responsive-page');
            document.documentElement.classList.remove('table-page-lock');
        };
    }, []);

    const toggleNavigationMenu = () => {
        const sideNavToggle = document.querySelector('[class*="sidenav-toggle"]');
        sideNavToggle?.click();
    };



    const sortData = (field) => {
        const sortedData = [...filteredSolicitudes].sort((a, b) => {
            if (
                field === "IDSolicitudes" ||
                field === "NombreEmpresa" ||
                field === "Ruta" ||
                field === "Contenedor" ||
                field === "PlacaTruck" ||
                field === "NombreConductor" ||
                field === "Contacto" ||
                field === "NombreInstalador" ||
                field === "Hora" ||
                field === "estado" ||
                field === "nota" ||
                field === "hora_e"
            ) {
                // Ordenar cadenas alfabéticamente (campo 'empresa')
                return (a[field] || "").localeCompare(b[field] || "");
            } else {
                return (a[field] || 0) - (b[field] || 0);
            }
        });

        // Cambia la dirección de orden si es necesario
        if (sortDirection === "desc") {
            sortedData.reverse();
        }

        setFilteredSolicitudes(sortedData);
        setSortBy(field);
        setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    };

    const getSolicitudCityId = (solicitud) => String(solicitud?.FKLokCiudadOrigen ?? '');
    const getSolicitudCityName = (solicitud) => {
        const city = ciudades.find((item) => String(item.ID) === getSolicitudCityId(solicitud));
        return city?.NOMBRE || solicitud?.CiudadOrigen || solicitud?.NombreCiudadOrigen || 'Sin ciudad';
    };

    const getSolicitudStatusKey = (data) => {
        if (data?.estado === 'Solicitud Cliente por Confirmar') return 'blue';
        if (!data?.Hora) return 'transparent';

        const horaCitaMs = parseServerUtcToMs(data.Hora);
        if (horaCitaMs == null) return 'transparent';

        const diferencia = (Date.now() - horaCitaMs) / 1000 / 60;
        if (diferencia >= 0) return 'red';
        if (diferencia >= -120) return 'yellow';
        if (diferencia >= -240) return 'green';
        return 'transparent';
    };

    const buildCountedOptions = (items, getValue, getLabel) => {
        const counts = new Map();
        items.forEach((item) => {
            const value = String(getValue(item) || '__SIN_VALOR__');
            const label = getLabel(item) || 'Sin asignar';
            const current = counts.get(value) || { value, label, count: 0 };
            current.count += 1;
            counts.set(value, current);
        });
        return Array.from(counts.values()).sort((a, b) => a.label.localeCompare(b.label, 'es'));
    };

    const cityOptions = useMemo(() => {
        const fromCatalog = ciudades.map((city) => ({
            value: String(city.ID),
            label: city.NOMBRE || 'Sin ciudad',
            count: listSolicitudes.filter((item) => String(item.FKLokCiudadOrigen ?? '') === String(city.ID)).length,
        }));
        const knownIds = new Set(fromCatalog.map((item) => item.value));
        const missing = buildCountedOptions(
            listSolicitudes.filter((item) => !knownIds.has(getSolicitudCityId(item))),
            getSolicitudCityId,
            getSolicitudCityName,
        );
        return [...fromCatalog.filter((item) => item.count > 0), ...missing];
    }, [ciudades, listSolicitudes]);

    const companyOptions = useMemo(
        () => buildCountedOptions(listSolicitudes, (item) => item.NombreEmpresa, (item) => item.NombreEmpresa),
        [listSolicitudes],
    );

    const filterSelectStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 20000 }),
        menu: (base) => ({ ...base, zIndex: 20000 }),
        control: (base, state) => ({
            ...base,
            minHeight: 54,
            height: 54,
            borderColor: state.isFocused ? '#5d8fba' : '#cfdce8',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 102, 153, .12)' : 'none',
            borderRadius: 10,
        }),
        multiValue: (base, state) => ({
            ...base,
            borderRadius: 999,
            backgroundColor: state.data?.badgeStyle?.backgroundColor || '#eaf2f8',
        }),
        multiValueLabel: (base, state) => ({
            ...base,
            color: state.data?.badgeStyle?.color || '#244d6d',
            fontWeight: 700,
        }),
    };

    const formatCountedOptionLabel = (option) => (
        <span className="solicitudes-filter-option-label">
            <span>{option.label}</span>
            <span
                className="solicitudes-filter-count-badge"
                style={option.badgeStyle}
            >
                {option.count}
            </span>
        </span>
    );

    const CountedOption = (props) => (
        <selectComponents.Option {...props}>
            {formatCountedOptionLabel(props.data)}
        </selectComponents.Option>
    );


    const renderSortIcon = (column) => {

        if (sortBy === column) {
            if (sortDirection === "asc") {
                return <span>&uarr;</span>; // Icono de flecha hacia arriba
            } else {
                return <span>&darr;</span>; // Icono de flecha hacia abajo
            }
        }

        return null; // No mostrar ningún ícono si no está ordenado por esta columna
    }

    const [isFullscreen, setIsFullScreen] = useState(false);

    const toggleFullscreen = () => {
        if (!isFullscreen) {
            // Activar el modo de pantalla completa
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
            }
        } else {
            // Desactivar el modo de pantalla completa
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }

        // Actualizar el estado
        setIsFullScreen(!isFullscreen);
    };

    const HandlePageByRole = async () => {
        let data = {
            pagina: "3",
        };

        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
                JSON.stringify(data),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            );

            if (res.data.success === false) {
                window.location.href = "/";
            } else {
                // console.log("BIt permisos: ", res.data.data);
                if (res.data.data.length > 0) {
                    setBitOpen(res.data.data[0].bitOpen);
                    setBitInsert(res.data.data[0].bitInsert);
                    setBitEdit(res.data.data[0].bitEdit);
                    setBitDelete(res.data.data[0].bitDelete);

                    if (res.data.data[0].bitOpen) {
                        console.warn("Tienes todos los permisos");
                    } else {
                        Swal.fire({
                            title: 'Información',
                            text: 'No tiene los permisos necesarios para acceder a esta página',
                            icon: 'info',
                            showConfirmButton: false,
                            timer: 3000,
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            },
                        }).then(() => {
                            window.location.href = "/principal"; // Redirect to another page
                        });
                    }
                }
            }
        } catch (error) {
            console.error("Error al listar bit permisos:", error);
        }
    };

    const handleSearchChange = (event) => {

        const value = event.target.value.toLowerCase();
        setSearchValue(value);
        sessionStorage.setItem(SOLICITUDES_SEARCH_STORAGE_KEY, value);
        localStorage.setItem("searchSolicitud", value);
    };

    //SHOW MODAL CREAR NUEVA SOLICITUD
    const showModalNewSolicitud = () => {
        if (bitInsert) {
            setIsDialogOpenNewSolicitud(true);
            // console.log(formType);
        } else {
            Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta opción',
                icon: 'info',
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            }).then(() => {
                console.error("No tienes permisos"); // Redirect to another page
            });
        }

    }
    //SHOW MODAL CREAR SOLCITUDmULTIPLE
    const showModalNewSolicitudMult = () => {
        // console.log("Modal abiertto");
        if (bitInsert) {
            setIsDialogOpenUpdateSolicitudMult(true);
            setFormTypeMult(<FormSolicitudesMult onClose={closeModalAndShowAlertDialogMult} clientes={clientes} />)
        } else {
            Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta opción',
                icon: 'info',
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            }).then(() => {
                console.error("No tienes permisos"); // Redirect to another page
            });
        }
    }

    //SHOW MODAL CAUSAL ELIMINACION DE SOLICITUD
    const showModalCausalEliminacionSolicitud = (id) => {
        if (bitDelete) {
            // console.log("Estoy entrando al modal de causal");
            setIsDialogOpenCausalAnular(true);
            setFormTypeCausalAnular(<CausalAnularSolicitud idSolicitud={id} onClose={closeModalCausalAnular} />)
        } else {
            Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta opción',
                icon: 'info',
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            }).then(() => {
                console.error("No tienes permisos"); // Redirect to another page
            });
        }
    }

    //SHOW MODAL REPORTE SEGUIMIENTO SOLICICITUD
    const showModalReporteSeguimientoSolicitud = (id) => {
        if (bitEdit) {
            setIsDialogOpenReportSeguimiento(true);
            setFormTypeReporteSeguimiento(<FormReporteSolicitudes idSolicitud={id} onClose={closeModalReporteSolcicitud} />)
        } else {
            Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta opción',
                icon: 'info',
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            }).then(() => {
                console.error("No tienes permisos"); // Redirect to another page
            });
        }
    }

    const showModalUpdateSolicitud = (IDSolicitud) => {
        if (bitEdit) {
            CargarInfoByIdSolicitud(IDSolicitud);
            let timerInterval;
            Swal.fire({
                title: "Estamos cargando la información de la solicitud",
                timer: 3000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                    // const timer = Swal.getPopup().querySelector("b");
                    // timerInterval = setInterval(() => {
                    //     timer.textContent = `${Swal.getTimerLeft()}`;
                    // }, 100);
                },
                willClose: () => {
                    clearInterval(timerInterval);
                    setIsDialogOpenUpdateSolicitud(true);
                }
            }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    // console.log("I was closed by the timer");
                }
            });
        } else {
            Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta opción',
                icon: 'info',
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            }).then(() => {
                console.error("No tienes permisos"); // Redirect to another page
            });
        }
    }

    //SHOW MODAL CREAR SOLICTUD SIN CAMPOS
    const showModalSolicitudDiffClient = () => {
        setIsDialogOpenNewSolicitudDiff(true);
        // console.log(formType);
    }

    const closeModalSolicitud = () => {
        setIsDialogOpenNewSolicitud(false);
        setIsDialogOpenNewSolicitudDiff(false);
    }

    const closeModalCausalAnular = () => {
        setIsDialogOpenCausalAnular(false);
        ListarContratos();
    }

    const closeModalReporteSolcicitud = () => {
        setIsDialogOpenReportSeguimiento(false);
        ListarContratos();
    }

    const closeModalSolicitudMult = () => {
        setIsDialogOpenUpdateSolicitudMult(false);
        setIsDialogOpenNewSolicitud(false);
        setIsDialogOpenNewSolicitudDiff(false);
    }

    const closeModalUpdateSolicitud = () => {
        setIsDialogOpenUpdateSolicitud(false);
    }

    //MANEJO DE CIERRRE DEL MODAL 
    const closeModalAndShowAlertDialog = () => {
        closeModalSolicitud();
        ListarContratos();
    }

    const closeModalAndShowAlertDialogMult = () => {
        closeModalSolicitudMult();
        ListarContratos();
    }

    const closeModalAndShowAlertDialogUpdate = () => {
        closeModalUpdateSolicitud();
        ListarContratos();
    }

    //CARGAR INFO FORMULARIO
    const CargarInfoByIdSolicitud = (idSolcicitud) => {
        let dataSolicitud = {
            id: idSolcicitud
        }
        axios
            .post(process.env.REACT_APP_SERVER + "/solicitudes/getobtenerSolicitud", JSON.stringify(dataSolicitud), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion de la solicitud", res.data.data);
                    setInfoByIdSolcitud(res.data.data);
                }
            }).catch((err) => console.error(err));
    }


    // METODO PARA LISTAR SOLICITUDES
    const ListarContratos = () => {
        setIsSolicitudesLoading(true);
        axios
            .get(process.env.REACT_APP_SERVER + "/solicitudes/getsolicitudes", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    console.log("Soliciitudes*******:", res.data.data);
                    setListSolicitudes(res.data.data);
                    setFilteredSolicitudesNotifications(res.data.data);
                    setFilteredSolicitudes(res.data.data);
                    if (searchValue) {
                        handleSearchChange({ target: { value: searchValue } });
                    }

                }
            }).catch((err) => console.error(err))
            .finally(() => setIsSolicitudesLoading(false));
    }

    //LISTAR CIUDADES
    const listarCiudades = () => {
        axios.get(process.env.REACT_APP_SERVER + "/solicitudes/getrutassolicitudesciudadorigen", {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
        })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Ciudades select: ", res.data.data);
                    setCiudades(res.data.data);
                    // this.setState({ listContratos: res.data.data }, () => {
                    //     this.handleSearchChange({ target: { value: $("#search").val() } });
                    // });
                }
            }).catch((err) => console.error(err));
    }

    //LISTAR CLIENTES
    const ListarClientes = () => {
        axios
            .get(process.env.REACT_APP_SERVER + "/solicitudes/getlistaempresas", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Xlientes", res.data);
                    // console.log("Xlientes tipo formulario ", res.data.formulario);
                    setStatusForm(res.data.formulario);
                    if (res.data.formulario === 'reducido') {
                        setFormType(<FormSolicitudesCli clientes={res.data.data} onClose={closeModalAndShowAlertDialog} statusForm={res.data.formulario} />);
                    } else if (res.data.formulario === 'completo') {
                        setFormType(<FormSolicitudesLog clientes={res.data.data} onClose={closeModalAndShowAlertDialog} statusForm={res.data.formulario} />);
                    }
                    setClientes(res.data.data);

                }
            }).catch((err) => console.error(err));
    }

    const parseServerUtcToMs = (value) => {
        if (!value) return null;
        if (value instanceof Date) return value.getTime();

        const raw = String(value).trim();
        if (!raw) return null;

        const plainMatch = raw.match(
            /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/
        );

        if (plainMatch) {
            const [, y, mo, d, h, mi, s = "00"] = plainMatch;
            return Date.UTC(
                Number(y),
                Number(mo) - 1,
                Number(d),
                Number(h),
                Number(mi),
                Number(s)
            );
        }

        const parsed = Date.parse(raw);
        return Number.isNaN(parsed) ? null : parsed;
    };

    const backgrounValidate = (data) => {
        if (data.estado === 'Solicitud Cliente por Confirmar') {
            return { backgroundColor: 'rgba(25, 160, 224, 0.5)' };
        }

        if (!data.Hora) {
            return { backgroundColor: 'transparent' }; // No hay hora, no cambiar el fondo
        }

        const horaCitaMs = parseServerUtcToMs(data.Hora);
        if (horaCitaMs == null) {
            return { backgroundColor: 'transparent' };
        }

        const diferencia = (Date.now() - horaCitaMs) / 1000 / 60; // Diferencia en minutos
        // console.log("diferencia: ", diferencia);

        if (diferencia >= 0) {

            return { backgroundColor: 'rgba(224, 43, 40, 0.5)', }; // Hora ya pasó, color rojo
        } else if (-120 <= diferencia && diferencia < 0) {

            return { backgroundColor: 'rgba(224, 160, 25, 0.5)' }; // Dentro de la próxima hora, color amarillo
        } else if (-240 <= diferencia && diferencia < -120) {

            return { backgroundColor: 'rgba(93, 224, 43, 0.5)' }; //  Dentro de las próximas 12 horas, color verde
        } else {

            return { backgroundColor: 'transparent' };
        }


    }

    const colorEstado = (estado) => {
        if (estado === 'Solicitud Cliente por Confirmar') {
            return { color: 'blue' };
        }
    }

    const countColorsSolicitudes = (solicitudes) => {
        let red = 0, yellow = 0, green = 0, transparent = 0, blue = 0;
        // console.log("solicitudes desde el contador de colores: ***** ", solicitudes);
        solicitudes.forEach(data => {
            if (data.estado === 'Solicitud Cliente por Confirmar') {
                blue++;
                return;
            }
            if (!data.Hora) {
                transparent++;
                return;
            }

            const horaCitaMs = parseServerUtcToMs(data.Hora);
            if (horaCitaMs == null) {
                transparent++;
                return;
            }

            const diferencia = (Date.now() - horaCitaMs) / 1000 / 60; // Diferencia en minutos
            // console.log("diferencia: ", diferencia);

            if (diferencia >= 0) {
                red++;
            } else if (-120 <= diferencia && diferencia < 0) {
                yellow++;
            } else if (-240 <= diferencia && diferencia < -120) {
                green++;
            } else {
                transparent++;
            }

        });

        setRedCount(red);
        setYellowCount(yellow);
        setGreenCount(green);
        setBlueCount(blue);
        setTransparentCount(transparent);
    }

    const updateSolicitudes = (newSolicitudes) => {
        setFilteredSolicitudes(newSolicitudes);
        setFilteredSolicitudesNotifications(newSolicitudes);
    };

    const colorFilterOptions = [
        { value: 'transparent', label: 'Sin hora / > 4 h', count: transparentCount, badgeStyle: { backgroundColor: '#fff', color: '#566d84' } },
        { value: 'red', label: 'Vencida', count: redCount, badgeStyle: { backgroundColor: '#f39a97', color: '#6f1f1b' } },
        { value: 'blue', label: 'Por confirmar', count: blueCount, badgeStyle: { backgroundColor: '#b9dff2', color: '#174263' } },
        { value: 'yellow', label: 'Próximas 2 h', count: yellowCount, badgeStyle: { backgroundColor: '#fff0b8', color: '#806500' } },
        { value: 'green', label: 'Próximas 2-4 h', count: greenCount, badgeStyle: { backgroundColor: '#c8f2b5', color: '#287516' } },
    ];

    const handleSolicitudAction = (action, data) => {
        setOpenSolicitudActions(null);

        if (action === 'edit') {
            showModalUpdateSolicitud(data.IDSolicitudes);
        } else if (action === 'report') {
            if (data.estado !== 'Solicitud Cliente por Confirmar') {
                showModalReporteSeguimientoSolicitud(data.IDSolicitudes);
            } else {
                Swal.fire({
                    title: 'Información',
                    text: 'No puede editar el reporte de seguimiento de una solicitud de cliente que no ha sido aceptada',
                    icon: 'info',
                    showConfirmButton: false,
                    timer: 3000,
                    allowOutsideClick: false,
                });
            }
        } else if (action === 'delete') {
            showModalCausalEliminacionSolicitud(data.IDSolicitudes);
        }
    };


    //CARGA DE SOLICITUDES
    const loadFillData = (array) => {
        // console.log("este es el array de la funcion loadFillData", filteredSolicitudes);

        return filteredSolicitudes.map((data) => {
            return (
                <React.Fragment >
                    {/* <tr onClick={() => this.toggleRow(data.ContractID)}> */}
                    <tr style={backgrounValidate(data)}>

                        <td
                            className="prueba solicitud-id-cell"
                            style={{ color: "#000" }}
                            onClick={() => handleSolicitudAction('edit', data)}
                            onContextMenu={(event) => {
                                event.preventDefault();
                                handleSolicitudAction('report', data);
                            }}
                            title="Clic izquierdo: editar · Clic derecho: agregar reporte"
                        >
                            <strong>{data.IDSolicitudes}</strong>
                        </td>
                        <td className="prueba" style={{ color: "#000" }}>
                            <strong>{data.NombreEmpresa}</strong>
                        </td>


                        <td style={{ color: "#000" }}>{data.Ruta}</td>

                        <td style={{ color: "#000" }}>
                            <div><strong>Placa:</strong> {data.PlacaTruck || "-"}</div>
                            <div><strong>Contenedor:</strong> {data.Contenedor || "-"}</div>
                        </td>


                        <td style={{ color: "#000" }}>
                            <div><strong>Nombre:</strong> {data.NombreConductor || "-"}</div>
                            <div><strong>Celular:</strong> {data.MovilConductor || "-"}</div>
                        </td>


                        <td style={{ color: "#000" }}>{data.Contacto}</td>


                        <td style={{ color: "#000" }}>{data.NombreInstalador}</td>


                        <td style={{ color: "#000" }}>{formattedGlobalDate(data.Hora)}</td>


                        <td style={{ color: "#000" }}>{data.estado}</td>


                        <td style={{ color: "#000" }}>{data.nota}</td>


                        <td style={{ color: "#000" }}>{formattedGlobalDate(data.hora_e)}</td>


                        <td className="solicitud-actions-cell">
                            <div className="solicitud-actions-dropdown">
                                <button
                                    type="button"
                                    className="solicitud-actions-trigger"
                                    aria-label={`Acciones para ${data.IDSolicitudes}`}
                                    aria-expanded={openSolicitudActions === data.IDSolicitudes}
                                    onClick={() => setOpenSolicitudActions((current) => current === data.IDSolicitudes ? null : data.IDSolicitudes)}
                                >
                                    <span aria-hidden="true">&#8942;</span>
                                </button>
                                {openSolicitudActions === data.IDSolicitudes && (
                                    <div className="solicitud-actions-menu" role="menu">
                                        <button type="button" role="menuitem" onClick={() => handleSolicitudAction('edit', data)}>
                                            <i className="bx bx-edit-alt" aria-hidden="true" />
                                            Editar
                                        </button>
                                        <button type="button" role="menuitem" onClick={() => handleSolicitudAction('report', data)}>
                                            <i className="bx bxs-plus-square" aria-hidden="true" />
                                            Agregar reporte
                                        </button>
                                        <button type="button" role="menuitem" onClick={() => handleSolicitudAction('delete', data)}>
                                            <i className="bx bx-trash" aria-hidden="true" />
                                            Anular
                                        </button>
                                    </div>
                                )}
                            </div>
                        </td>





                    </tr>
                </React.Fragment >
            )
        })
    }

    useEffect(() => {
        if (infoByIdSolcitud && statusForm === 'reducido') {
            setFormTypeUpdate(<FormUpdateSolicitudCli clientes={clientes} onClose={closeModalAndShowAlertDialogUpdate} info={infoByIdSolcitud} />);
        } else if (infoByIdSolcitud && statusForm === 'completo') {
            setFormTypeUpdate(<FormUpdateSolicitudLog clientes={clientes} onClose={closeModalAndShowAlertDialogUpdate} info={infoByIdSolcitud} />);
        }
    }, [infoByIdSolcitud]);

    useEffect(() => {
        ListarContratos();
        listarCiudades();
        ListarClientes();
    }, []);

    useEffect(() => {
        const normalizedSearch = searchValue.trim().toLowerCase();
        const selectedCityIds = new Set(selectedCiudades.map((item) => String(item.value)));
        const selectedCompanyNames = new Set(selectedEmpresas.map((item) => String(item.value).toLowerCase()));
        const selectedStatuses = new Set(selectedColorFilters.map((item) => item.value));

        const filteredWithoutStatus = listSolicitudes.filter((solicitud) => {
            const searchableText = [
                solicitud.IDSolicitudes,
                solicitud.NombreEmpresa,
                solicitud.Ruta,
                solicitud.PlacaTruck,
                solicitud.Contenedor,
                solicitud.Contacto,
                solicitud.NombreInstalador,
                solicitud.Hora,
                solicitud.estado,
                solicitud.nota,
                solicitud.hora_e,
                solicitud.Ref,
            ].filter(Boolean).join(' ').toLowerCase();

            const matchesSearch = !normalizedSearch || searchableText.includes(normalizedSearch);
            const matchesCity = selectedCityIds.size === 0 || selectedCityIds.has(getSolicitudCityId(solicitud));
            const matchesCompany = selectedCompanyNames.size === 0 || selectedCompanyNames.has(String(solicitud.NombreEmpresa || '').toLowerCase());
            return matchesSearch && matchesCity && matchesCompany;
        });

        countColorsSolicitudes(filteredWithoutStatus);
        const nextFiltered = selectedStatuses.size === 0
            ? filteredWithoutStatus
            : filteredWithoutStatus.filter((solicitud) => selectedStatuses.has(getSolicitudStatusKey(solicitud)));

        setFilteredSolicitudes(nextFiltered);
        setFilteredSolicitudesNotifications(nextFiltered);
    }, [listSolicitudes, searchValue, selectedCiudades, selectedEmpresas, selectedColorFilters]);

    useEffect(() => { HandlePageByRole(); }, []);

    // useEffect(() => {
    //     ListarContratos();
    //     const intervalId = setInterval(() => {
    //         ListarContratos();
    //         console.warn("Actualizando solicitudes");
    //     }, 1000);
    //     return () => clearInterval(intervalId);
    // }, []);



    return (
        <>
            <BaseModalCreateSolcitud isOpen={isDialogOpenNewSolicitud} onClose={closeModalSolicitud} title={'Crear solicitud1'} childComponent={formType} />
            <BaseModalCreateSolcitud isOpen={isDialogOpenUpdateSolicitud} onClose={closeModalUpdateSolicitud} title={'Actualizar solicitud'} childComponent={formTypeUpdate} />
            <BaseModalCreateSolcitud isOpen={isDialogOpenUpdateSolicitudMult} onClose={closeModalSolicitudMult} title={'Solicitudes multiples'} childComponent={formTypeMult} />
            <CausalModal isOpen={isDialogOpenCausalAnular} onClose={closeModalCausalAnular} title={'Causal de eliminacion de la solicitud'} childComponent={formTypeMCausalAnular} />
            <ReporteSeguimientoModal isOpen={isDialogOpenReportSeguimiento} onClose={closeModalReporteSolcicitud} title={'Reporte de Seguimiento de Solicitudes'} childComponent={formTypeReporteSeguimiento} />
            {/* <CreateSolicitud open={isDialogOpenNewSolicitud} onOpenChange={setIsDialogOpenNewSolicitud} /> */}
            <div className="layout-wrapper layout-content-navbar solicitudes-page">
                <div className="layout-container">
                    <div className="layout-page">
                        <div className="solicitudes-navbar-wrap">
                            <button
                                type="button"
                                className="platform-navbar-menu-toggle solicitudes-mobile-menu-toggle"
                                onClick={toggleNavigationMenu}
                                aria-label="Abrir menú de navegación"
                                title="Menú de navegación"
                            >
                                <i className="bx bx-menu" aria-hidden="true" />
                            </button>
                            <BarraSolicitud count={blueCount} filteredSolicitudes={filteredSolicitudesNotifications} onUpdateSolicitudes={updateSolicitudes} ListarContratos={ListarContratos} />
                        </div>
                        {isSolicitudesLoading && (
                            <div className="solicitudes-responsive-loader" role="status" aria-live="polite">
                                <div className="solicitudes-responsive-spinner" aria-hidden="true" />
                                <span>Cargando información...</span>
                            </div>
                        )}
                        {bitOpen && (
                            <div className="content-wrapper">
                                <div className="container-fluid flex-grow-1 container-p-y">
                                    <MDBRow className="solicitudes-toolbar align-items-center">
                                        <MDBCol md="8" className="solicitudes-heading">
                                            <label
                                                className="fw-bold mb-4 label_trafico"
                                                style={{ fontSize: "22px", marginRight: "10px" }}
                                            >
                                                Control de solicitudes
                                            </label>
                                            <p className="solicitudes-subtitle">Gestiona y da seguimiento a todas las solicitudes</p>

                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow className="solicitudes-controls-row align-items-center">
                                        <MDBCol md="1" className="solicitudes-fullscreen">
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={() => toggleFullscreen()}
                                            >
                                                {isFullscreen ? (
                                                    <FaCompress />
                                                ) : (
                                                    <FaExpand />
                                                )}
                                            </button>
                                        </MDBCol>

                                        <MDBCol md="3" className="solicitudes-search">
                                            <div className="input-group col-md-12">
                                                <span className="input-group-text" id="b1">
                                                    <FaSearch />
                                                </span>
                                                <input
                                                    id="searchSolicitud"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Empresa, ruta, placa o contenedor"
                                                    aria-describedby="b1"
                                                    value={searchValue}
                                                    onChange={handleSearchChange}
                                                />
                                            </div>
                                        </MDBCol>
                                        {/* <MDBCol md="1">
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                data-bs-toggle="offcanvas"
                                                data-bs-target="#offcanvasEnd"
                                                aria-controls="offcanvasEnd"
                                            >
                                                <FaFilter />
                                            </button>
                                        </MDBCol> */}
                                        <MDBCol md={4} className='labelRowSelect solicitudes-multi-filter solicitudes-city-filter'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                isClearable
                                                options={cityOptions}
                                                value={selectedCiudades}
                                                onChange={(value) => setSelectedCiudades(value || [])}
                                                placeholder="Ciudades de origen"
                                                noOptionsMessage={() => 'No hay ciudades disponibles'}
                                                formatOptionLabel={formatCountedOptionLabel}
                                                components={{ Option: CountedOption }}
                                                styles={filterSelectStyles}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                classNamePrefix="solicitudes-select"
                                                aria-label="Ciudades de origen"
                                            />
                                        </MDBCol>
                                        <MDBCol md={4} className='labelRowSelect solicitudes-multi-filter solicitudes-company-filter'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                isClearable
                                                options={companyOptions}
                                                value={selectedEmpresas}
                                                onChange={(value) => setSelectedEmpresas(value || [])}
                                                placeholder="Empresas"
                                                noOptionsMessage={() => 'No hay empresas disponibles'}
                                                formatOptionLabel={formatCountedOptionLabel}
                                                components={{ Option: CountedOption }}
                                                styles={filterSelectStyles}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                classNamePrefix="solicitudes-select"
                                                aria-label="Empresas"
                                            />
                                        </MDBCol>
                                        <MDBCol md={4} className='solicitudes-status-filter'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                isClearable
                                                options={colorFilterOptions}
                                                value={selectedColorFilters}
                                                onChange={(value) => setSelectedColorFilters(value || [])}
                                                placeholder="Estados"
                                                noOptionsMessage={() => 'No hay estados disponibles'}
                                                formatOptionLabel={formatCountedOptionLabel}
                                                components={{ Option: CountedOption }}
                                                styles={filterSelectStyles}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                classNamePrefix="solicitudes-select"
                                                aria-label="Filtrar por estado de solicitud"
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow className="solicitudes-actions-row">
                                        <MDBCol md={4} className='buttonSolicitudes'>
                                            <button onClick={showModalNewSolicitud}
                                            >
                                                <i className="bx bx-file" aria-hidden="true" /> Crear solicitud única
                                            </button>
                                            {statusForm === 'completo' ? (
                                                <button onClick={showModalNewSolicitudMult}>
                                                    <i className="bx bx-layer" aria-hidden="true" /> Crear solicitudes múltiples
                                                </button>
                                            ) : (null)}
                                        </MDBCol>
                                    </MDBRow>

                                    <div className="card cardContainerControlDevice controlSolicitudes">
                                        <div
                                            className="table-responsive solicitudes-table-wrapper"
                                            style={{
                                                height: `calc(100vh - 250px)`,
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                                display: "flex",
                                                // flexDirection: "column",
                                            }}
                                        >
                                            <table className="table table-hover solicitudes-table" id="tabla">
                                                <colgroup>
                                                    <col style={{ width: '7%' }} />
                                                    <col style={{ width: '10%' }} />
                                                    <col style={{ width: '10%' }} />
                                                    <col style={{ width: '9%' }} />
                                                    <col style={{ width: '12%' }} />
                                                    <col style={{ width: '9%' }} />
                                                    <col style={{ width: '10%' }} />
                                                    <col style={{ width: '7%' }} />
                                                    <col style={{ width: '8%' }} />
                                                    <col style={{ width: '8%' }} />
                                                    <col style={{ width: '7%' }} />
                                                    <col style={{ width: '3%' }} />
                                                </colgroup>
                                                <thead className="FondoHeaderTabla2">
                                                    <tr>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("IDSolicitudes")}
                                                        >
                                                            ID {renderSortIcon("IDSolicitudes")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("NombreEmpresa")}
                                                        >
                                                            EMPRESA{" "}
                                                            {renderSortIcon("NombreEmpresa")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("Ruta")}
                                                        >
                                                            RUTA {renderSortIcon("Ruta")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("PlacaTruck")}
                                                        >
                                                            PLACA {renderSortIcon("PlacaTruck")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("NombreConductor")}
                                                        >
                                                            CONDUCTOR {" "}{renderSortIcon("NombreConductor")}
                                                        </th>

                                                        <th style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("Contacto")}
                                                        >
                                                            CONTACTO {" "}{renderSortIcon("Contacto")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("NombreInstalador")}
                                                        >
                                                            INSTALADOR {renderSortIcon("NombreInstalador")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("Hora")}
                                                        >
                                                            HORA SERVICIO{" "}
                                                            {renderSortIcon("Hora")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("estado")}
                                                        >
                                                            ESTADO{" "}
                                                            {renderSortIcon("estado")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("nota")}
                                                        >
                                                            NOTA{" "}
                                                            {renderSortIcon("nota")}
                                                        </th>

                                                        <th
                                                            style={{ color: "#ffffff" }}
                                                            onClick={() => sortData("hora_e")}
                                                        >
                                                            ULT.NOTA{" "}
                                                            {renderSortIcon("hora_e")}
                                                        </th>

                                                        <th style={{ color: "#ffffff" }}></th>


                                                    </tr>
                                                </thead>
                                                <tbody className="table-border-bottom-0" id="tabladata">
                                                    {loadFillData(listSolicitudes)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="controlSolicitudes2">
                                        <SolicitudesResponsive
                                            listSolicitudes={listSolicitudes}
                                            filteredSolicitudes={filteredSolicitudes}
                                            showModalUpdateSolicitud={showModalUpdateSolicitud}
                                            showModalCausal={showModalCausalEliminacionSolicitud}
                                            showModalAddReport={showModalReporteSeguimientoSolicitud}
                                        />

                                    </div>

                                </div>
                                <div className="content-backdrop fade"></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Solicitudes
